/// \file localDBCalls.ts
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.
import { TimestampToDate } from "../components/timestampToDate";
import updateCookie from "./updateCookie";

//This entire file pretty much fully sends commands to API.js in server/routes

const checkLogout = async() => {
    const validUser = await LocalDBCalls.checkUserIsValid();
    if(validUser!=1){ //log them out
        throw("invalid user")
    }
    return("")
}

const apiSender = async(method:string, baseUrl:string, cookie:any, header?:any, messagebody?:any) => {
    let headers:any = {
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, PATCH, OPTIONS',
        'Accept': 'text/html, application/json, text/plain, */*',
        'Access-Control-Expose-Headers': 'token, set-cookie',
        'cookie': cookie,
        "Content-Type":"application/json",
    }
    if(messagebody!=undefined){
        for (let key in header){
            if(header[key]!=undefined){
                headers[key] = header[key]
            }
        }
        const apiResponse = await fetch(baseUrl,{method:method,headers:headers,body:JSON.stringify(messagebody)});
        return(apiResponse)
    }
    else{
        for (let key in header){
            if(header[key]!=undefined){
                headers[key] = header[key]
            }
        }
        const apiResponse = await fetch(baseUrl,{method:method,headers:headers});
        return(apiResponse)
    }

}

const getIP = async() => {
    try{
        const apiResponse = await fetch('https://api.ipify.org/?format=json');
        const apiResponseData = await apiResponse.json();
        console.log("getIP apiResponseData: ", apiResponseData)
        return(apiResponseData.ip?apiResponseData.ip:"?.?.?.?");
    }
    catch(error:any){
        console.log("fetch for ip failed: ", error);
        return("?.?.?.?")
    }
}

const LocalDBCalls = {
    checkUserIsValid: async function(){ //0 == update password, 1 == good password, 2 == signup
        try{
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath+'/API/checkToken'
            
            const expressReturn = await apiSender("GET",baseUrl,document.cookie);
            const expressReturnData = await expressReturn.json()
            if(expressReturnData.valid==true){
                return(1)
            }
            return(0)
        }
        catch (e:any){
            console.error("unknown and unexpected error")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return(2)
        }
    },

    getUserInfo: async function(headerCookies:string){
        try{
            if(headerCookies){
                const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
                const baseUrl = originPath+'/API/checkToken'
                const expressReturn = await apiSender("GET",baseUrl,document.cookie);
                const expressReturnData = await expressReturn.json()
                if(expressReturnData.valid==true){
                    return(expressReturnData.data)
                }
                return("")
            }
            else{
                return("")
            }
        }
        catch (e:any){
            console.error("unknown and unexpected error")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return("")
        }
    },

    checkPassIsValid: function(headerCookies:string){
        try{
            if(headerCookies){
                const cookies = headerCookies.split(";");
                for(let i=0;i<cookies.length;i++){
                   const cookieString = cookies[i].replaceAll(" ","").split("=");
                   const cookieName = cookieString[0];
                   if(cookieName=="expired"){
                      return(Number(cookieString[1]));
                   }
                }
                return(0)
            }
            else{
                return(0)
            }
        }
        catch (e:any){
            console.error("unknown and unexpected error")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return(2)
        }
    },

    toAuth: async function(path:string, commandType:string, cookie:string, username:string, password:string){

        try{
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/login';
        const ip = await getIP();
        const expressReturn = await apiSender("GET",baseUrl,document.cookie,{'username': username,'password': password,'path': path, 'ip':ip});
        const expressReturnData = await expressReturn.json();
        const response = expressReturnData;
        const user = response.data.user;
        const obj:any = {}
        if(user){
            localStorage.setItem('user',user.name)
            localStorage.setItem('customer_id',user.customer_id)
            let crumbJSON = [{id:user.customer_id,text:"Top-Level",action:"customer"}]
            localStorage.setItem('customer-crumbs',JSON.stringify(crumbJSON));
        }
        if(expressReturnData.token){
            const expressToken = expressReturnData.token
            const cookiePathSplit = expressToken.split(";");
            const cookieSplit = cookiePathSplit[0].split("=");
            obj[cookieSplit[0].trim()] = cookieSplit[1].trim();
            if(cookieSplit[0].trim()=="token"){
                document.cookie = expressReturnData.token
                updateCookie.updateTokenTime()
            }
        }
        else{
            //timestamp to date:
            const fullMessage = expressReturnData.message;
            const splitMessage = fullMessage.split("until ");
            if(splitMessage && splitMessage[1]){
                const newTime = TimestampToDate({timestamp:(Number(splitMessage[1])+60*60*1000).toString(),numberPass:true});
                splitMessage[1] = newTime;
            }
            return {"message":splitMessage.join("until "),"data":""};
        }

        obj["NumRefreshes"] = 0;
        return expressReturnData;
        }
        catch (e:any){
            console.error("invalid auth")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    getId: async function(path:string, cookie:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/userId';
        const expressReturn = await apiSender("GET",baseUrl,document.cookie);
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        const user = response.user;
        const obj:any = {}
        return {"message":response.message,"data":user.id};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    newUser: async function(path:string, cookie:string, username:string, email:string, firstname:string, lastname:string, password:string, customer_id:string, level:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        let userInfo = "---";
        if(username && email && firstname && lastname && password && customer_id && level){//CMS-697 if we don't have all the info we need
            userInfo = path+'?username='+username+'&profile={"email":"'+email+'","firstName":"'+firstname+'","lastName":"'+lastname+'","mobile":"","office":""}&password='+password+'&customer_id='+customer_id+'&level='+level
        }
        const baseUrl = originPath+'/API/signup';
        const expressReturn = await apiSender("POST",baseUrl,document.cookie,{'userquery':userInfo});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        const user = response.data.data;
        return {"message":response.message,"data":user};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    analytics: async function(path:string, cookie:string, vin:string, startdate:string, enddate:string, analytics:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/analytics';
        const expressReturn = await apiSender("GET",baseUrl,document.cookie,{'vin': vin,'startdate': startdate,'enddate': enddate,'analytics': analytics,});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        return {"message":response.message,"data":response.data};
        }
        catch (e:any){
            console.error("invalid analytics request")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    hourlyAnalytics: async function(path:string, cookie:string, vin:string, startdate:string, enddate:string, analytics:string){
        //need to be based on timezone (dates might need to adjust accordingly)
        try{
        await checkLogout()
        const currentTime = new Date();
        let sendStart = startdate;
        let sendEnd = enddate;
        let labels:string[] = []
            try{
                const newStartDateString = startdate.slice(0,2)+"-"+startdate.slice(2,4)+"-"+startdate.slice(4)
                const newEndDateString = enddate.slice(0,2)+"-"+enddate.slice(2,4)+"-"+enddate.slice(4)
                const startDate = new Date(newStartDateString);
                const endDate = new Date(newEndDateString);
                
                //start date back one day and end date up one day:
                const newStartDate = startDate;
                newStartDate.setDate(startDate.getDate()-1);
                const newEndDate = endDate;
                newEndDate.setDate(endDate.getDate()+1);

                //date object to format MMDDYYYY
                sendStart = (newStartDate.getMonth()<9)?"0"+(newStartDate.getMonth()+1).toString():(newStartDate.getMonth()+1).toString();
                sendStart += (newStartDate.getDate()<=9)?"0"+newStartDate.getDate().toString():newStartDate.getDate().toString();
                sendStart += newStartDate.getFullYear().toString();

                sendEnd = (newEndDate.getMonth()<9)?"0"+(newEndDate.getMonth()+1).toString():(newEndDate.getMonth()+1).toString();
                sendEnd += (newEndDate.getDate()<=9)?"0"+newEndDate.getDate().toString():newEndDate.getDate().toString();
                sendEnd += newEndDate.getFullYear().toString();

                //make the new labels:
                startDate.setDate(startDate.getDate()+1);
                let labelStart = ((startDate.getMonth()<9)?"0"+(startDate.getMonth()+1).toString():(startDate.getMonth()+1).toString()) + "/" +
                ((startDate.getDate()<=9)?"0"+startDate.getDate().toString():startDate.getDate().toString()) + "/" +
                startDate.getFullYear().toString();
                const labelEnd = ((endDate.getMonth()<9)?"0"+(endDate.getMonth()+1).toString():(endDate.getMonth()+1).toString()) + "/" +
                ((endDate.getDate()<=9)?"0"+endDate.getDate().toString():endDate.getDate().toString()) + "/" +
                endDate.getFullYear().toString();
                let looper = 0;
                while(labelStart!=labelEnd && looper<30){//just while testing no month of this
                    for(let i=0;i<24;i++){
                        labels.push(labelStart+"/"+((i<=9)?"0"+i.toString():i.toString())+":00")
                    }
                    startDate.setDate(startDate.getDate()+1);
                    labelStart = ((startDate.getMonth()<9)?"0"+(startDate.getMonth()+1).toString():(startDate.getMonth()+1).toString()) + "/" +
                    ((startDate.getDate()<=9)?"0"+startDate.getDate().toString():startDate.getDate().toString()) + "/" +
                    startDate.getFullYear().toString();
                    looper +=1
                }
            }
            catch(e){
                console.error("WARNING: new dates did not work: ",e)
            }
        const diff = currentTime.getTimezoneOffset();
        const hourDiff = Math.round(diff/60);
        //if hourDiff were negative, need the previous day value
        //need to add one day to each end and then truncate on return
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;

        const baseUrl = originPath+'/API/hourlyAnalytics';
        const expressReturn = await apiSender("GET",baseUrl,document.cookie,{'vin': vin,'startdate': sendStart,'enddate': sendEnd,'analytics': analytics,});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        //before the data is pasted back, we should adjust the timestamps to help the other parts of the code and keep the conversion in one spot
        const returnData = response.data.slice(24+hourDiff,-1*(24-hourDiff));
        for(let j=0;j<returnData.length;j++){
            const datapiece = returnData[j];
            if(labels[j] && datapiece && datapiece.date){
                datapiece.date = labels[j];
                returnData[j] = datapiece;
            }
        }
        return {"message":response.message,"data":returnData};
        }
        catch (e:any){
            console.error("invalid analytics request")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    addUser: async function(path:string, cookie:string, userquery:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const basePathNoPort = window.location.protocol+'//'+ window.location.hostname
        const baseUrl = originPath+'/API/addUser';
        const expressReturn = await apiSender("POST",baseUrl,document.cookie,{'userquery': userquery,'baseurlpath': basePathNoPort,'path': path,});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        const user = response.data;
        const obj:any = {}
        return {"message":response.message,"data":user};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    removeUser: async function(path:string, cookie:string, queryString:string){
        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const basePathNoPort = window.location.protocol+'//'+ window.location.hostname
        const baseUrl = originPath+'/API/removeUser';
        const expressReturn = await apiSender("DELETE",baseUrl,document.cookie,{'deleteuserinfo': queryString,'baseurlpath': basePathNoPort,'path': path});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        const user = response.data;
        const obj:any = {}
        return {"message":response.message,"data":user};
        }
        catch (e:any){
            console.error("invalid removing user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    //just the level
    updateLevel: async function(cookie:string, id:string, level:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/updateLevel';
        const expressReturn = await apiSender("POST",baseUrl,document.cookie,{'level': level,'id': id,});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        const status = response.status;
        let valid = false;
        if(status==200){
            valid = true;
        }
        return {"message":response.message,"data":valid,"content":response};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":false,"content":e};
        }
    },

    //just the access level
    updateAccessLevel: async function(cookie:string, id:string, accesslevel:string){
        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/updateAccessLevel';
        const expressReturn = await apiSender("POST",baseUrl,document.cookie,{'accessType': accesslevel,'id': id,});
        const expressReturnData = await expressReturn.json()
        const response = expressReturnData;
        const status = response.status;
        let valid = false;
        if(status==200){
            valid = true;
        }
        return {"message":response.message,"data":valid,"content":response};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":false,"content":e};
        }
    },

    //profilequery: starts profile=blahblahblah
    updateProfile: async function(cookie:string, id:string, profilequery:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/updateProfile';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'id': id,'profilequery': profilequery});
        const response = await expressReturn.json();
        const status = expressReturn.status;
        let valid = false;
        if(status==200){
            valid = true;
        }
        return {"message":response.message,"data":valid,"content":response};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":false,"content":e};
        }
    },

    updatePreference: async function(cookie:string, id:string, preferencequery:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/updatePreferences';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'id': id,'preferencequery': preferencequery});
        const response = await expressReturn.json();
        return {"message":response.message,"data":response.data};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    resetPassword: async function(cookie:string, username:string, email:string){

        try{
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/resetPassword';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'username': username,'email': email});
        const response = await expressReturn.json();
        const user = response.data.data;
        const obj:any = {}
        return {"message":response.message,"data":user,"content":response};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":"","content":e};
        }
    },

    //for admins to force users to create a new password, untested
    forceResetPassword: async function(cookie:string, id:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/forceResetPassword';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'id': id});
        const response = await expressReturn.json();
        const status = response.status;
        const obj:any = {}
        return {"message":response.message,"data":status,"response":response};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },

    updatePassword: async function(path:string, cookie:string, id:string, oldPassword:string, newPassword:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const reqquery = path+"?id="+id+"&oldPassword="+encodeURIComponent(oldPassword)+"&newPassword="+encodeURIComponent(newPassword)
        const baseUrl = originPath+'/API/updatePassword';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'reqquery': reqquery});
        const response = await expressReturn.json();
        const status = response.status;
        let valid = false;
        if(status==200){ //want to add a test if the message does not contain the word invalid
            valid = true;
        }
        return {"message":response.message,"data":valid,"content":response};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":false,"content":e};
        }
    },

    changeCustomer: async function(path:string, cookie:string, customerid:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const reqquery = "?customer_id="+customerid;
        const baseUrl = originPath+'/API/changeCustomer';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'reqquery': reqquery});
        const response = await expressReturn.json();
        if(expressReturn.status==200){
            return {"message":response.message,"content":response.content,"valid":true};
        }
        return {"message":response.message,"content":response.content,"valid":false};
        }
        catch (e:any){
            console.error("invalid new user")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e,"content":"","valid":false};
        }
    },

    //untested
    lockouts: async function(cookie:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/lockouts';
        const expressReturn = await apiSender("GET",baseUrl,cookie);
        const response = await expressReturn.json();
        const data = response.data;
        return {"message":response.message,"data":data,"content":response};
        }
        catch (e:any){
            console.error("invalid lockout pull")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":"","content":e};
        }
    },

    securityLogs: async function(commandType:string, cookie:string, dataquery:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/securityLogs';
        const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery});
        const response = await expressReturn.json();
        const data = response.data;
        return {"message":response.message,"data":data,"content":response};
        }
        catch (e:any){
            console.error("invalid login failure pull")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":"","content":e};
        }
    },

    securityLogsCount: async function(commandType:string, cookie:string, dataquery:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/securityLogsCount';
        const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery});
        const response = await expressReturn.json();
        const data = response.data;
        return {"message":response.message,"data":data,"content":response};
        }
        catch (e:any){
            console.error("invalid login failure pull")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":"","content":e};
        }
    },

    //untested
    clearLockout: async function(cookie:string, id:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/clearLockout';
        const expressReturn = await apiSender("POST",baseUrl,cookie,{'id': id});
        const response = await expressReturn.json();
        const data = response.data;
        return {"message":response.message,"data":data,"content":response};
        }
        catch (e:any){
            console.error("invalid lockout clear")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":"","content":e};
        }
    },

    //untested
    toUser: async function(path:string, commandType:string, cookie:string, userquery?:string){

        try{
        await checkLogout()
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/user'
            if(commandType=="get"){
                try{
                    if(path == "user/all")//old version into an if check
                    {
                        const expressReturn = await apiSender("GET",baseUrl,cookie,{'path': path});
                        const response = await expressReturn.json();
                        return response;
                    }
                    else//specifiy a user id in the path.
                    {
                        const expressReturn = await apiSender("GET",baseUrl,cookie,{'path': path});
                        const response = await expressReturn.json();
                        return response;
                    }
                }
                catch (e:any){
                    console.error("invalid user")
                    console.error("code: " , e.code);
                    console.error("message: " , e.message);
                    return {"message":e.message,"data":(e.response?e.response.data:e.message)};
                }
            }
            else if(commandType=="put"){
                try{
                    const path2 = userquery?("?"+userquery):"";
                    const expressReturn = await apiSender("PUT",baseUrl+path+path2,cookie,{'path': path});
                    const response = await expressReturn.json();
                    return response.data;
                }
                catch (e:any){
                    console.error("invalid user")
                    console.error("code: " , e.code);
                    console.error("message: " , e.message);
                    return {"message":e.message,"data":(e.response?e.response.data:e.message)};
                }
            }
            else if(commandType=="delete"){
                try{
                    const path2 = userquery;
                    if(userquery){
                        const expressReturn = await apiSender("DELETE",baseUrl+path+"?id="+path2,cookie,{'path': path});
                        const response = await expressReturn.json();
                        return response.data;
                    }
                    else{
                        console.error("user id is not sent...can not delete")
                        return {"message":"user id is not sent...can not delete"};
                    }
                }
                catch (e:any){
                    console.error("invalid user")
                    console.error("error: " , e);
                    console.error("code: " , e.code);
                    console.error("message: " , e.message);
                    return {"message":e.message,"data":(e.response?e.response.data:e.message)};
                }
            }
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
    },

    //untested
    toSecurity: async function(path:string, commandType:string, cookie:string, userquery?:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/security'
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'token': cookie,"security": "security",'path': path+userquery});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid user")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="put"){
            try{
                const path2 = userquery?("?"+userquery):"";
                const expressReturn = await apiSender("PUT",baseUrl+path+path2,cookie,{'token': cookie,"security": "security",'path': path});
                const response = await expressReturn.json();
                return response.data;
            }
            catch (e:any){
                console.error("invalid user")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="delete"){
            try{
                const path2 = userquery;
                if(userquery){
                    const expressReturn = await apiSender("DELETE",baseUrl+path+"?id="+path2,cookie,{'token': cookie,"security": "security",'path': path});
                    const response = await expressReturn.json();
                    return response.data;
                }
                else{
                    console.error("user id is not sent...can not delete")
                    return {"message":"user id is not sent...can not delete"};
                }
            }
            catch (e:any){
                console.error("invalid user")
                console.error("error: " , e);
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    //untested
    toAccessLevel: async function(path:string, commandType:string, cookie:string, username:string, levels:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const baseUrl = '//cmsapi:3002/api/'
        if(commandType=="get"){
            try{
                const path2 = levels?("?id="+levels):"";
                const expressReturn = await apiSender("GET",baseUrl+path+path2,cookie,{'token': cookie,'username': username});
                const response = await expressReturn.json();
                return response;
                }
            catch (e:any){
                console.error("invalid level")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="put"){
            try{
                const path2 = levels?("?"+levels):"";
                const expressReturn = await apiSender("PUT",baseUrl+path+path2,cookie,{'token': cookie,'username': username});
                const response = await expressReturn.json();
                return response.data;
                }
            catch (e:any){
                console.error("invalid level")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="delete"){
            try{
                const path2 = levels;
                if(levels){
                    const expressReturn = await apiSender("DELETE",baseUrl+path+"?id="+path2,cookie,{'token': cookie,'username': username});
                    const response = await expressReturn.json();
                    return response.data;
                }
                else{
                    console.error("level id is not sent...can not delete")
                    return {"message":"level id is not sent...can not delete"};
                }
            }
            catch (e:any){
                console.error("invalid level")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    toAsset: async function(path:string, commandType:string, cookie:string, customer:string, asset:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/asset';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'assetquery': asset,"path": path,"customerid":customer,'token': cookie});
                const response = await expressReturn.json();            
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="put"){
            try{
                const expressReturn = await apiSender("POST",baseUrl,cookie,{'assetquery': asset,"path": path,"customerid":customer,'token': cookie});
                const response = await expressReturn.json();   
                return response.data;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="delete"){
            try{
                const path2 = asset;
                if(asset){
                    const expressReturn = await apiSender("DELETE",baseUrl+path+"?id="+path2,cookie,{'assetquery': asset,"path": path,"customerid":customer,'token': cookie});
                    const response = await expressReturn.json();   
                    return response.data;
                }
                else{
                    console.error("asset id is not sent...can not delete")
                    return {"message":"asset id is not sent...can not delete"};
                }
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },


    //untested
    toCustomer: async function(path:string, commandType:string, cookie:string, username:string, customer:string){
        try{
            await checkLogout()
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath+'/API/Customer'
            if(commandType=="get"){
                try{
                    const expressReturn = await apiSender("GET",baseUrl,cookie,{"path": path,"customer":customer,'token': cookie});
                    const response = await expressReturn.json();                  
                    return response;
                }
                catch (e:any){
                    console.error("invalid customer")
                    console.error("code: " , e.code);
                    console.error("message: " , e.message);
                    return {"message":e.message,"data":(e.response?e.response.data:e.message)};
                }
            }
            else if(commandType=="get/all")
            {
                const expressReturn = await apiSender("GET",baseUrl,cookie,{"path": path,"customer":customer,'token': cookie});
                const response = await expressReturn.json();   
                const obj:any = {}
                if(response.data){
                    return {"message":response.message,"data": response.data}
                }
                else{
                    return {"message":response.message,"data":""};
                }
            }
            else if(commandType=="put"){
                try{
                    const path2 = customer?("?"+customer):"";
                    const expressReturn = await apiSender("PUT",baseUrl+path+path2,cookie,{"path": path,"customer":customer,'token': cookie});
                    const response = await expressReturn.json();
                    return response.data;
                }
                catch (e:any){
                    console.error("LocalDBCalls::toCustomer::put - invalid customer")
                    console.error("LocalDBCalls::toCustomer::put - code: " , e.code);
                    console.error("LocalDBCalls::toCustomer::put - message: " , e.message);
                    return {"message":e.message,"data":(e.response?e.response.data:e.message)};
                }
            }
            else if(commandType=="delete"){
                console.log("attempting to delete customer: ", customer,baseUrl+path+"?id="+customer)
                try{
                    const path2 = customer;
                    if(customer){
                        const expressReturn = await apiSender("DELETE",baseUrl+path,cookie,{"path": path+"?id="+path2,"customer":customer,'token': cookie});
                        const response = await expressReturn.json();  
                        return response;
                    }
                    else{
                        console.error("customer id is not sent...can not delete")
                        return {"message":"customer id is not sent...can not delete"};
                    }
                }
                catch (e:any){
                    console.error("invalid customer")
                    console.error("code: " , e.code);
                    console.error("message: " , e.message);
                    return {"message":e.message,"data":(e.response?e.response.data:e.message)};
                }
            }
        }
        catch (e:any){
            console.error("invalid auth")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":""};
        }
    },
    
    toData: async function(path:string, commandType:string, cookie:string, customerid:string, data:string, vin?:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/data';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': data,"path": path,'token': cookie,"vin": vin,"customerid":customerid});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="put"){
            try{
                const expressReturn = await apiSender("POST",baseUrl,cookie,{'dataquery': data,"path": path,'token': cookie,"vin": vin,"customerid":customerid});
                const response = await expressReturn.json();  
                return response.data;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="delete"){
            try{
                const path2 = data;
                if(data){
                    const expressReturn = await apiSender("DELETE",baseUrl+path+"?id="+path2,cookie,{'dataquery': data,"path": path,'token': cookie,"vin": vin,"customerid":customerid});
                    const response = await expressReturn.json();  
                    return response.data;
                }
                else{
                    console.error("data id is not sent...can not delete")
                    return {"message":"data id is not sent...can not delete"};
                }
            }
            catch (e:any){
                console.error("invalid data")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    unitData: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/unitdata';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/unitData",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    unitDataCount: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/unitdatacount';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/unitDataCount",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    unitDataNew: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/unitdata';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/unitDataNew",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    unitDataCountNew: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/unitdatacount';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/unitDataCountNew",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    historicalFaults: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/historicalfaults';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/historicalFaults",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    historicalFaultsCount: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/historicalfaultscount';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/historicalFaultsCount",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    getAdminEvents: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/getAdminEvents';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/getAdminEvents",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    getDataItems: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/getDataItems';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "data/getDataItems",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    toBigData: async function(path:string, commandType:string, cookie:string, customerid:string, data:string, vin?:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/bigdata';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': data,"path": path,'token': cookie,"vin": vin,"customerid":customerid});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="put"){
            try{
                const expressReturn = await apiSender("POST",baseUrl,cookie,{'dataquery': data,"path": path,'token': cookie,"vin": vin,"customerid":customerid});
                const response = await expressReturn.json();              
                return response.data;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="delete"){
            try{
                const path2 = data;
                if(data){
                    const expressReturn = await apiSender("DELETE",baseUrl+path+"?id="+path2,cookie,{'dataquery': data,"path": path,'token': cookie,"vin": vin,"customerid":customerid});
                    const response = await expressReturn.json();       
                    return response.data;
                }
                else{
                    console.error("data id is not sent...can not delete")
                    return {"message":"data id is not sent...can not delete"};
                }
            }
            catch (e:any){
                console.error("invalid data")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    sendEmail: async function(path:string, commandType:string, cookie:string, email:string, message:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const data = {"message":message};
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/email';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'email': email,'cookie': cookie,"Content-Type":"multipart/form-data"});
                const response = await expressReturn.json();              
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
        else if(commandType=="put"){
            try{
                const expressReturn = await apiSender("POST",baseUrl,cookie,{'email': email,'cookie': cookie},JSON.stringify(data));
                const response = await expressReturn.json();         
                return response.data;
            }
            catch (e:any){
                console.error("invalid email / did not send")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message)};
            }
        }
    },

    //customerquery needs to be id=customerid&assetId=assetid
    assignAsset: async function(cookie:string, customerquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/assignAsset';
        try{
            const expressReturn = await apiSender("POST",baseUrl,cookie,{"customerquery":customerquery});
            const response = await expressReturn.json(); 
            return response.data;
        }
        catch (e:any){
            console.error("invalid assetId or customerId")
            console.error("customerquery: ",customerquery)
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //customerquery needs to be id=customerid&assetId=assetid
    unassignAsset: async function(cookie:string, customerquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/unassignAsset';
        try{
            const expressReturn = await apiSender("POST",baseUrl,cookie,{"customerquery":customerquery});
            const response = await expressReturn.json(); 
            return response.data;
        }
        catch (e:any){
            console.error("invalid assetId or customerId")
            console.error("customerquery: ",customerquery)
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //customerquery needs to be id=customerid&details={}
    customerDetails: async function(cookie:string, customerquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/customerDetails';
        try{
            const expressReturn = await apiSender("POST",baseUrl,cookie,{"customerquery":customerquery});
            const response = await expressReturn.json(); 
            return response.data;
        }
        catch (e:any){
            console.error("invalid customerId or customerDetails")
            console.error("customerquery: ",customerquery)
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //customerquery needs to be id=customerid&location={}
    customerLocation: async function(cookie:string, customerquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/customerLocation';
        try{
            const expressReturn = await apiSender("POST",baseUrl,cookie,{"customerquery":customerquery});
            const response = await expressReturn.json(); 
            return response.data;
        }
        catch (e:any){
            console.error("invalid customerId or customerLocation")
            console.error("customerquery: ",customerquery)
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //customerquery needs to be id=customerid&preferences={}
    customerPreferences: async function(cookie:string, customerquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/customerPreferences';
        try{
            const expressReturn = await apiSender("POST",baseUrl,cookie,{"customerquery":customerquery});
            const response = await expressReturn.json(); 
            return response.data;
        }
        catch (e:any){
            console.error("invalid customerId or customerPreferences")
            console.error("customerquery: ",customerquery)
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //customerquery needs to be id=customerid&preferences={}
    updateUserCustomerLink: async function(cookie:string, querystring:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/updateUserCustomerLink';
        try{
            const expressReturn = await apiSender("POST",baseUrl,cookie,{"querystring":querystring});
            const response = await expressReturn.json();             
            return response.data;
        }
        catch (e:any){
            console.error("invalid customerId or customerPreferences")
            console.error("querystring: ",querystring)
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    getCustomerFleet: async function(cookie:string, customer:string, assetquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/getCustomerFleet';
        try{
            const expressReturn = await apiSender("GET",baseUrl,cookie,{'assetquery': assetquery,"customerid":customer,'token': cookie});
            const response = await expressReturn.json();            
            return response;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    toTCO: async function(cookie:string, messagebody:any){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        try{
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath + '/API/tcoCalc';
            
            // const response = await apiPost(originPath,baseUrl,cookie,messagebody);
            const response = await apiSender("POST",baseUrl,cookie,undefined,messagebody);
            
            const responseCheck = await response.json()                
            return responseCheck;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    // DO NOT ADD question mark.  data query includes startTime, endTime, (all:boolean OR vin:string OR customerId:string)
    getDataTimerange: async function(cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/getDataTimerange';
        try{
            const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,'token': cookie});
            const response = await expressReturn.json();            
            return response;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //rule, description, message, permissionid, severityid, interval
    createRule: async function(cookie:string, alertquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        try{
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath + '/API/createRule';
            
            const response = await apiSender("POST",baseUrl,cookie,{alertquery:alertquery});
            
            const responseCheck = await response.json()                
            return responseCheck;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //alertId
    removeRule: async function(cookie:string, alertquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        try{
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath + '/API/removeRule';
            
            const response = await apiSender("POST",baseUrl,cookie,{alertquery:alertquery});
            
            const responseCheck = await response.json()                
            return responseCheck;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    getAlerts: async function(cookie:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        try{
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath + '/API/getAlerts';
            
            const response = await apiSender("GET",baseUrl,cookie);
            
            const responseCheck = await response.json()                
            return responseCheck;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    //rule, description, message, permissionid, severityid, interval
    assignAlertAsset: async function(cookie:string, alertquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        try{
            const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
            const baseUrl = originPath + '/API/assignAlertAsset';
            
            const response = await apiSender("POST",baseUrl,cookie,{alertquery:alertquery});
            
            const responseCheck = await response.json()                
            return responseCheck;
        }
        catch (e:any){
            console.error("invalid asset")
            console.error("code: " , e.code);
            console.error("message: " , e.message);
            return {"message":e.message,"data":(e.response?e.response.data:e.message)};
        }
    },

    getDailyAnalytics: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/getDailyAnalytics';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "getDailyAnalytics",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message), "error":true};
            }
        }
    },

    getSummaryAnalytics: async function(commandType:string, cookie:string, dataquery:string){
        try{
            await checkLogout()
        }
        catch(e){
            return {"message":e,"data":(e)};
        }
        const originPath = window.location.protocol+'//'+ window.location.hostname+":"+window.location.port;
        const baseUrl = originPath+'/API/getSummaryAnalytics';
        if(commandType=="get"){
            try{
                const expressReturn = await apiSender("GET",baseUrl,cookie,{'dataquery': dataquery,"path": "getSummaryAnalytics",'token': cookie});
                const response = await expressReturn.json();
                return response;
            }
            catch (e:any){
                console.error("invalid asset")
                console.error("code: " , e.code);
                console.error("message: " , e.message);
                return {"message":e.message,"data":(e.response?e.response.data:e.message), "error":true};
            }
        }
    },
}

export default LocalDBCalls;
